export default __webpack_public_path__ + "static/media/CommeSi60s.1e477add.mp3";